import styled from '@emotion/styled';
import { Tooltip } from '@mui/material';
import ButtonDropdownMenuProps from 'common/types/ButtonDropdownMenuProps';
import React from 'react';

const StyledButton = styled.button`
  outline: none;
  cursor: pointer;
  background-color: ${(props) => props.theme.colors.secondaryColor};
  height: 40px;
  min-width: 40px;
  padding: 8px;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.gray};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
  position: relative;
  &:hover {
    background-color: ${(props) => props.theme.colors.secondaryHoverColor};
    border-color: ${(props) => props.theme.colors.primaryColor};
  }
  &.active {
    background-color: ${(props) => props.theme.colors.secondaryHoverColor};
    border-color: ${(props) => props.theme.colors.primaryColor};
  }
`;

type StyledDropdownMenuProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  theme?: any;
  position?: 'left' | 'right';
};

const StyledDropdownMenu = styled.div<StyledDropdownMenuProps>`
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.gray};
  padding: 16px;
  background: ${(props) => props.theme.colors.secondaryColor};
  position: absolute;
  z-index: 100;
  top: 48px;
  ${(props) => props.position === 'right' && 'left: 0;'};
  ${(props) => props.position === 'left' && 'right: 0;'};
  display:flex;
  flex-direction: column;
  gap:8px;
  filter: drop-shadow(0px 6px 8px rgba(6, 10, 25, 0.25));
`;


const StyledMenuButton = styled.a`
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  display:flex;
  font-family: Mulish;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%; /* 16px */
  color: ${(props) => props.theme.colors.primaryTextColor};
  letter-spacing: 1px;
  &:hover {
    color: ${(props) => props.theme.colors.primaryColor};
  };
`;

const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${(props) => props.theme.colors.gray};
`;

type IconButtonProps = {
  children: React.ReactNode;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  menuData: ButtonDropdownMenuProps[];
  isOpen: boolean;
  position?: 'left' | 'right';
  label?: string;
  labelPosition?:
  | 'bottom-end'
  | 'bottom-start'
  | 'bottom'
  | 'left-end'
  | 'left-start'
  | 'left'
  | 'right-end'
  | 'right-start'
  | 'right'
  | 'top-end'
  | 'top-start'
  | 'top';
};

const MenuIconButton = ({ children, onClick, menuData, isOpen, label, labelPosition, position }: IconButtonProps) => {

  const Jsx = (
    <>
      {menuData && isOpen && (
        <StyledDropdownMenu position={position || 'right'} onClick={(e) => { e.stopPropagation(); }}>
          {menuData.map((item, index) => (
            <React.Fragment key={index}>
              <StyledMenuButton onClick={(e: React.MouseEvent<HTMLAnchorElement>) => { console.log(e); item.onClick(); }}>
                {item.label}
              </StyledMenuButton>
              {index !== menuData.length - 1 && <Separator />}
            </React.Fragment>
          ))}
        </StyledDropdownMenu>
      )}
    </>
  );

  if (!label) {
    return (
      <StyledButton className={isOpen && 'active'} onClick={onClick}>
        {children}
        {Jsx}
      </StyledButton>
    );
  }
  return (
    <StyledButton className={isOpen && 'active'} onClick={onClick}>
      <Tooltip placement={labelPosition || 'bottom'} title={label || ''} >
        <div style={{ width: '100%', height:'100%', display:'flex', justifyContent:'center', alignItems:'center' }}>
          {children}
        </div>
      </Tooltip>
      {Jsx}
    </StyledButton>
  );
};

export default MenuIconButton;
